import { Card, Row, Col } from "react-bootstrap";
import {
  RiCalendarLine,
  RiCheckLine,
  RiTimeLine,
  RiCloseLine,
  RiErrorWarningLine,
} from "react-icons/ri";

export default function BookingStats() {
  const stats = [
    { icon: <RiCalendarLine />, value: 37, label: "Total Bookings", color: "#2563eb", bg: "#e0edff" },
    { icon: <RiCheckLine />, value: 28, label: "Completed", color: "#16a34a", bg: "#e6f4ea", percent: "75.7%" },
    { icon: <RiTimeLine />, value: 5, label: "Upcoming", color: "#f59e0b", bg: "#fff4e5", percent: "13.5%" },
    { icon: <RiCloseLine />, value: 4, label: "Cancelled", color: "#ef4444", bg: "#fee2e2", percent: "10.8%" },
    { icon: <RiErrorWarningLine />, value: 2, label: "No Show", color: "#8b5cf6", bg: "#f3e8ff", percent: "5.4%" },
  ];

  return (
    <Row className="bh-stats">
      {stats.map((s, i) => (
        <Col xl={2} lg={4} md={6} sm={6} xs={12} key={i}>
          <Card className="bh-card mt-0">
            <div className="bh-icon" style={{ background: s.bg, color: s.color }}>
              {s.icon}
            </div>
            <div>
              <h5>{s.value}</h5>
              <p>{s.label}</p>
            </div>
              {s.percent && <span className="bh-percent">{s.percent}</span>}
          </Card>
        </Col>
      ))}
    </Row>
  );
}